module.exports = __webpack_public_path__ + "img/28_2004_yim.f712ca41.jpg";